export enum WebsocketStatus {
  Disconnected = 'Disconnected',
  Connected = 'Connected',
  Connecting = 'Connecting',
  Error = 'Error',
}
